import Envelopes from './views/Envelopes'
export default [{
  path: '/edi/envelopes',
  name: 'edi.envelopes',
  component: Envelopes
}]
